<script setup lang="ts">
import { useIdentityStore } from '@/store/identity.store';
import { onMounted, ref } from 'vue';

interface Props {
    allOf?: string[] | undefined;
    anyOf?: string[] | undefined;
    notAnyOf?: string[] | undefined;
}
const props = defineProps({
  allOf: null,
  anyOf: null,
  notAnyOf: null
});
const authorized = ref<boolean>(false);
const store = useIdentityStore();

onMounted(() => {
    authorized.value = store.authorized(props.allOf, props.anyOf, props.notAnyOf);
});
</script>

<template>
    <slot v-if="authorized"></slot>
    <slot v-if="authorized" name="authorized"></slot>
    <slot v-else name="notAuthorized"></slot>
</template>
